module.exports = __webpack_public_path__ + "assets/65db3eef4a1104b9502095b1fcea6371.mp4";